import { useState } from 'react';

const useCommentForm = () => {
    const [replyTo, setReplyTo] = useState<number | undefined>();

    const handleReply = (commentId: number) => {
        setReplyTo(commentId);
    };

    return {
        replyTo,
        handleReply
    };
}

export default useCommentForm;